import type { BookGenre } from '@booknest/shared';

export interface GenreMeta {
  readonly value: BookGenre;
  readonly label: string;
  readonly emoji: string;
}

/**
 * Métadonnées d'affichage pour chaque genre Booknest. Libellés FR sauf
 * marketing terms gardés en EN (Romance, Dark Romance, Romantasy, Fantasy,
 * Thriller, Horror, Young Adult, Feel-good). Ordre = ordre d'affichage UI.
 */
export const GENRE_META: ReadonlyArray<GenreMeta> = [
  { value: 'fiction', label: 'Fiction', emoji: '📖' },
  { value: 'romance', label: 'Romance', emoji: '🌹' },
  { value: 'dark-romance', label: 'Dark Romance', emoji: '🖤' },
  { value: 'romantasy', label: 'Romantasy', emoji: '🐉' },
  { value: 'fantasy', label: 'Fantasy', emoji: '🔮' },
  { value: 'science-fiction', label: 'Science-fiction', emoji: '🚀' },
  { value: 'thriller', label: 'Thriller', emoji: '🔪' },
  { value: 'policier', label: 'Policier', emoji: '🕵️' },
  { value: 'mystery', label: 'Mystère', emoji: '🔍' },
  { value: 'horror', label: 'Horror', emoji: '👻' },
  { value: 'young-adult', label: 'Young Adult', emoji: '🌙' },
  { value: 'feel-good', label: 'Feel-good', emoji: '☕' },
  { value: 'historique', label: 'Historique', emoji: '⚔️' },
  { value: 'classique', label: 'Classique', emoji: '🏛️' },
  { value: 'litterature-fr', label: 'Littérature FR', emoji: '🇫🇷' },
  { value: 'biographie', label: 'Biographie', emoji: '👤' },
  { value: 'histoire', label: 'Histoire', emoji: '📜' },
  { value: 'essai', label: 'Essai', emoji: '💭' },
  { value: 'dev-perso', label: 'Développement perso', emoji: '🌱' },
  { value: 'poesie', label: 'Poésie', emoji: '🪶' },
  { value: 'bd-manga', label: 'BD / Manga', emoji: '💥' },
  { value: 'jeunesse', label: 'Jeunesse', emoji: '🧸' },
  { value: 'other', label: 'Autre', emoji: '✨' },
];

const BY_VALUE = new Map(GENRE_META.map((m) => [m.value, m]));

export function genreMeta(genre: BookGenre): GenreMeta {
  return BY_VALUE.get(genre) ?? GENRE_META[GENRE_META.length - 1]!;
}
